import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\Works\WorkSourceFactsController::__invoke
* @see app/Http/Controllers/Works/WorkSourceFactsController.php:14
* @route '/works/{work}/source-facts'
*/
export const show = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/works/{work}/source-facts',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Works\WorkSourceFactsController::__invoke
* @see app/Http/Controllers/Works/WorkSourceFactsController.php:14
* @route '/works/{work}/source-facts'
*/
show.url = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { work: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { work: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            work: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        work: typeof args.work === 'object'
        ? args.work.slug
        : args.work,
    }

    return show.definition.url
            .replace('{work}', parsedArgs.work.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Works\WorkSourceFactsController::__invoke
* @see app/Http/Controllers/Works/WorkSourceFactsController.php:14
* @route '/works/{work}/source-facts'
*/
show.get = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkSourceFactsController::__invoke
* @see app/Http/Controllers/Works/WorkSourceFactsController.php:14
* @route '/works/{work}/source-facts'
*/
show.head = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Works\WorkSourceFactsController::__invoke
* @see app/Http/Controllers/Works/WorkSourceFactsController.php:14
* @route '/works/{work}/source-facts'
*/
const showForm = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkSourceFactsController::__invoke
* @see app/Http/Controllers/Works/WorkSourceFactsController.php:14
* @route '/works/{work}/source-facts'
*/
showForm.get = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Works\WorkSourceFactsController::__invoke
* @see app/Http/Controllers/Works/WorkSourceFactsController.php:14
* @route '/works/{work}/source-facts'
*/
showForm.head = (args: { work: string | { slug: string } } | [work: string | { slug: string } ] | string | { slug: string }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

const sourceFacts = {
    show: Object.assign(show, show),
}

export default sourceFacts